import { render, staticRenderFns } from "./TagSetting.vue?vue&type=template&id=15dd2b4d&"
import script from "./TagSetting.vue?vue&type=script&lang=js&"
export * from "./TagSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports